/**
 * Created by PJPERF on 05.04.2017.
 */
import React from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

class Table extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      test: false,
    };
  }
  handleSelect(row, isSelected) {
    if (typeof this.props.handleSelect === "function") {
      if (isSelected) {
        this.props.handleSelect(row[this.props.table_key], row);
      } else {
        this.props.handleSelect();
      }
    }
  }
  cellStyle(fieldValue, row, rowIdx, colIdx) {
    if (rowIdx === 2 && colIdx === 1) console.log(this);

    return "";
  }
  render() {
    let wrap_className = "table_wrap " + this.props.name;
    if (this.props.table_class)
      wrap_className = wrap_className + " " + this.props.table_class;
    const selectRow = {
      mode: "radio", // multi select
      clickToSelect: true,
      onSelect: this.handleSelect.bind(this),
      bgColor: "#E4F2F3",
      hideSelectColumn: true,
      selected: [this.props.selected],
    };
    //TODO: col_width obsolete, need to refactor actual forms
    let col_width = this.props.col_width ? this.props.col_width : {};
    let headers = this.props.headers;
    let data =
      this.props.data && this.props.data.length > 0 ? this.props.data : [];

    return (
      <div className={wrap_className}>
        <BootstrapTable
          ref="table"
          selectRow={
            typeof this.props.handleSelect === "function" ? selectRow : {}
          }
          hover={true}
          keyField={this.props.table_key}
          bodyStyle={{ wordBreak: "break-all" }}
          data={data}
          striped
          options={{ noDataText: "No data" }}
        >
          {Object.keys(this.props.headers).map(function (key) {
            return (
              <TableHeaderColumn
                key={key}
                width={col_width[key] || headers[key].width}
                dataField={key}
              >
                {headers[key].label}
              </TableHeaderColumn>
            );
          })}
        </BootstrapTable>
      </div>
    );
  }
}

export default Table;
